var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_1245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1442 18.4296L25.2984 23.5827L23.5956 25.2856L18.4425 20.1313C16.5252 21.6683 14.1403 22.5043 11.6829 22.5008C5.70427 22.5008 0.852051 17.6486 0.852051 11.67C0.852051 5.69134 5.70427 0.839111 11.6829 0.839111C17.6615 0.839111 22.5137 5.69134 22.5137 11.67C22.5172 14.1274 21.6813 16.5122 20.1442 18.4296ZM17.7301 17.5367C19.2575 15.9661 20.1103 13.8607 20.1069 11.67C20.1069 7.01511 16.3365 3.24597 11.6829 3.24597C7.02804 3.24597 3.25891 7.01511 3.25891 11.67C3.25891 16.3236 7.02804 20.094 11.6829 20.094C13.8737 20.0975 15.979 19.2445 17.5496 17.7172L17.7301 17.5367Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_1245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.272,
    height: 25.272,
    fill: "white",
    transform: "translate(0.839111 0.839111)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.676f10e0fad422f5e3369fd20e57a1fc.svg";
export { ForwardRef as ReactComponent };